import { createAction, props } from '@ngrx/store';

import {
  EntidadProductivaYActividades
} from '@rpe/registro-personas-empresas-lib';
import { Error } from '@rpe/registro-personas-empresas-lib/src/lib/extras/extra-error';

// LOAD
export const entityEntidadesProductivaActividadLoadRequest = createAction(
  '[ENTITYENTIDADESPRODUCTIVAACTIVID] Load Request'
);

export const entityEntidadesProductivaActividadLoadFailure = createAction(
  '[ENTITYENTIDADESPRODUCTIVAACTIVID] Load Failure',
  props<{ error: Error }>()
);

export const entityEntidadesProductivaActividadLoadSuccess = createAction(
  '[ENTITYENTIDADESPRODUCTIVAACTIVID] Load Success',
  props<{ items: EntidadProductivaYActividades }>()
);
/*
// ADD
export const entityEntidadesProductivaActividadAddRequest = createAction(
  '[ENTITYENTIDADESPRODUCTIVAACTIVID] Add Request',
  props<{ item: EntidadesProductivaActividad }>()
);

export const entityEntidadesProductivaActividadAddFailure = createAction(
  '[ENTITYENTIDADESPRODUCTIVAACTIVID] Add Failure',
  props<{ error: Error }>()
);

export const entityEntidadesProductivaActividadAddSuccess = createAction(
  '[ENTITYENTIDADESPRODUCTIVAACTIVID] Add Success',
  props<{ item: EntidadesProductivaActividad }>()
);

// CHANGE
export const entityEntidadesProductivaActividadChangeRequest = createAction(
  '[ENTITYENTIDADESPRODUCTIVAACTIVID] Change Request',
  props<{ item: EntidadesProductivaActividad }>()
);

export const entityEntidadesProductivaActividadChangeFailure = createAction(
  '[ENTITYENTIDADESPRODUCTIVAACTIVID] Change Failure',
  props<{ error: Error }>()
);

export const entityEntidadesProductivaActividadChangeSuccess = createAction(
  '[ENTITYENTIDADESPRODUCTIVAACTIVID] Change Success',
  props<{ item: Update<EntidadesProductivaActividad> }>()
);

// DELETE
export const entityEntidadesProductivaActividadDeleteRequest = createAction(
  '[ENTITYENTIDADESPRODUCTIVAACTIVID] Delete Request',
  props<{ item: EntidadesProductivaActividad }>()
);

export const entityEntidadesProductivaActividadDeleteFailure = createAction(
  '[ENTITYENTIDADESPRODUCTIVAACTIVID] Delete Failure',
  props<{ error: Error }>()
);

export const entityEntidadesProductivaActividadDeleteSuccess = createAction(
  '[ENTITYENTIDADESPRODUCTIVAACTIVID] Delete Success',
  props<{ item: EntidadesProductivaActividad }>()
);*/
